import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onClearFilters, onReturnToIntake }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-12 text-center">
      <div className="max-w-md mx-auto">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="SearchX" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-2">
          No Helpers Found
        </h3>
        <p className="text-muted-foreground mb-6">
          We couldn't find any helpers matching your current filters. Try adjusting your search criteria or clearing filters to see more options.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Button
            variant="outline"
            iconName="RotateCcw"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Clear Filters
          </Button>
          <Button
            variant="default"
            iconName="ArrowLeft"
            iconPosition="left"
            onClick={onReturnToIntake}
          >
            Update Preferences
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;